import _taggedTemplateLiteral from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import styled from "styled-components";
import { size } from "../../../../shared/constants";
import Button from "../../../Button";
export var AddToCartButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0 ", "px ", "px;\n  margin-top: auto;\n"])), size.md, size.md);